// @flow

import { get } from 'lodash';

import features from '../features';

import type { Feature, Plan } from '@zapier/billing/src/utils';

/**
 * Lists the features lost between from plan and to plan
 */
export default (from: Plan, to: ?Plan): Array<Feature> =>
  features.filter(feature => get(from, feature.key) && !get(to, feature.key));
